import { render, staticRenderFns } from "./payPopup.vue?vue&type=template&id=caf2a35e&"
import script from "./payPopup.vue?vue&type=script&lang=js&"
export * from "./payPopup.vue?vue&type=script&lang=js&"
import style0 from "./payPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports